import { render, staticRenderFns } from "./NavbarInput.vue?vue&type=template&id=56748734&"
import script from "./NavbarInput.vue?vue&type=script&lang=js&"
export * from "./NavbarInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports